import { Injectable } from '@angular/core';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Pagination, Response } from '../../../_shared/models';
import { DriverDocuments, DocumentType, UploadedDocuments, UpdateDriverDocument, DeleteDriverDocument } from '../models/driver-documents.model';
import { DriversListPaginationRequest } from '../models/driver-pagination-request.model';
import { DriverInformation } from '../models/drivers.model';
import { DriverExpiryAlert, DriverExpiryAlertRequest } from '../models/document-expiry-alert.model';

@Injectable({
  providedIn: 'root'
})
export class DriverDocumentsService {

  constructor(private http: HttpClient) { }

  async getDocumentTypes(): Promise<Response<DocumentType[]>> {
    return firstValueFrom(this.http.get<Response<DocumentType[]>>(`${environment.apiEndpoint}/driverdocuments/document-types`));
  }

  getDriverDocumentExpiryAlerts(request: DriverExpiryAlertRequest): Promise<Response<DriverExpiryAlert[]>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverdocuments/document-expiry-alert`, request));
  }

  public getDriversList(request: DriversListPaginationRequest, cancellation: Subject<void>): Promise<Response<Pagination<DriverInformation[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverdocuments/paginated-drivers`, request).pipe(takeUntil(cancellation)));
  }

  async getDriverDocuments(driverId: number): Promise<Response<DriverDocuments[]>> {
    return firstValueFrom(this.http.get(`${environment.apiEndpoint}/driverdocuments/${driverId}`));
  }

  async uploadTempDocuments(tempDocFormData: FormData): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverdocuments/upload-temp-document`, tempDocFormData));
  }

  async uploadDriverDocument(driverDocuments: UploadedDocuments[]): Promise<Response<any>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/driverdocuments/upload`, { documents: driverDocuments }));
  }

  async updateDriverDocument(driverDocument: UpdateDriverDocument): Promise<Response<any>> {
    return firstValueFrom(this.http.put(`${environment.apiEndpoint}/driverdocuments/update`, driverDocument));
  }

  async deleteDriverDocument(document: DeleteDriverDocument) {
    return firstValueFrom(this.http.delete(`${environment.apiEndpoint}/driverdocuments/delete`, { body: document }));
  }
}